import { render, staticRenderFns } from "./ShouhuoAddr.vue?vue&type=template&id=01c878d6&scoped=true&"
import script from "./ShouhuoAddr.vue?vue&type=script&lang=js&"
export * from "./ShouhuoAddr.vue?vue&type=script&lang=js&"
import style0 from "./ShouhuoAddr.vue?vue&type=style&index=0&id=01c878d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c878d6",
  null
  
)

export default component.exports